import React, { memo } from 'react';
import { DialogWrapper } from '@common/components/modal/dialog-wrapper';
import { APIEmployeeAcademyCourseOverview } from '@modules/learning/types/objects';
import CourseCard from './course-card';
import './courses-overview-modal.scss';

type CoursesOverviewModalProps = {
  title: string;
  courses: APIEmployeeAcademyCourseOverview[];
  onHide: () => void;
};

const MAX_COURSES_PER_ROW = 6;

const CoursesOverviewModal = memo(({ title, courses, onHide }: CoursesOverviewModalProps) => {
  const sizeLarge = courses.length >= MAX_COURSES_PER_ROW;
  return (
    <DialogWrapper
      size={sizeLarge ? 'large' : undefined}
      show
      className={`CoursesOverviewModal ${sizeLarge ? 'CoursesOverviewModal--large' : ''}`}
      onHide={onHide}
      title={title}
      hideFooter
      content={
        courses.map((course) => (
          <CourseCard key={course.id} course={course} />
        ))
      }
    />
  );
});

export default CoursesOverviewModal;
